export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: { default: 'opt' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.notice_label_noticeOrderNo') || '订单通知书编号',
    field: 'noticeOrderNo',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.notice_label_noticeByName') || '通知人',
    field: 'noticeByName',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'noticeByName' },
  },
  {
    title: that.$l('menu_text_nc') || 'NC赋码',
    field: 'noticeOrderStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'noticeOrderStatus' },
  },
  {
    title: that.$l('menu_text_money') || '成本测算',
    field: 'noticeCostStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'noticeCostStatus' },
  },
  {
    title: that.$l('table_label_notice_plan') || '计划安排',
    field: 'noticePlanStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'noticePlanStatus' },
  },
  {
    title: that.$l('INDEX.order_form_label_orderNo') || '订单编号',
    field: 'orderNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_custOrderNo') || '客户订单编号',
    field: 'custOrderNo',
    width: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_factoryOrderNo') || '工厂订单编号',
    field: 'factoryOrderNo',
    width: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_custCode') || '下单客户',
    field: 'custName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_endCustCode') || '终端客户',
    field: 'endCustName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_brand') || '客户品牌',
    field: 'brandName',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_salesPersonCode') || '业务人员名字',
    field: 'salesPersonName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_bizPersonCode') || '跟单人员',
    field: 'bizPersonName',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_noticeBizPersonName') || '工厂跟单人员',
    field: 'noticeBizPersonName',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_takeOverTime') || '工厂跟单接手时间',
    field: 'bizPersonTakeOverTime',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_orderType') || '订单类型',
    field: 'v_orderType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_orderExecuteType') || '执行方式',
    field: 'v_orderExecuteType',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.order_form_label_orderSource') || '订单合同名称 (甲方)',
    field: 'v_orderSource',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_importanceLevel') || '订单性质',
    field: 'v_importanceLevel',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_scmCode') || '执行工厂',
    field: 'scmName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_orderScmCode') || '名义工厂',
    field: 'orderScmCodeName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_settlementFactory') || '结算工厂',
    field: 'settlementFactoryName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_Total_order_cost') || '订单总价',
    field: 'orderAmount',
    width: 160,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      const { orderAmount: value, v_currencyUnit: unit } = row
      return `${that.format(value)} ${unit}`
    },
  },
  {
    title:
      that.$l('INDEX.order_form_label_factoryPaymentTerms') || '工厂付款条件',
    field: 'v_factoryPaymentTerms',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_orderStatus') || '订单状态',
    field: 'v_orderStatus',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'orderStatus' },
  },
]
